import { Customer } from '../gql/customerGql';
import { DealContact } from '../gql/dealContactGql';
import { Customer as GeneratedCustomer, Maybe } from '../gql/generated/graphql';

export const getNamesObject = (
  fullName?: string,
): Pick<Customer | DealContact, 'first_name' | 'middle_name' | 'last_name'> => {
  if (!fullName) {
    return {
      first_name: '',
      middle_name: '',
      last_name: '',
    };
  }

  const nameParts = fullName.split(' ').filter((part) => part !== '');
  if (nameParts.length === 1) {
    return {
      first_name: fullName,
      middle_name: '',
      last_name: '',
    };
  }
  if (nameParts.length === 2) {
    return {
      first_name: nameParts[0],
      middle_name: '',
      last_name: nameParts[1],
    };
  }

  return {
    first_name: nameParts[0],
    middle_name: nameParts.slice(1, nameParts.length - 1).join(' '),
    last_name: nameParts[nameParts.length - 1],
  };
};

// TODO: move the logic from `CreditPerson` here and rename it to `cleanCustomer`.
// This is called in the Apollo middleware
export const cleanCustomer = (customer: Customer | GeneratedCustomer) => {
  const cleanedCustomer = { ...customer };

  if ('prequalification' in cleanedCustomer) {
    delete cleanedCustomer.prequalification;
  }
  if ('secure_link' in cleanedCustomer) {
    delete cleanedCustomer.secure_link;
  }
  if ('mailingAddressSameHasResidential' in cleanedCustomer) {
    delete cleanedCustomer.mailingAddressSameHasResidential;
  }
  if ('auth0_id' in cleanedCustomer) {
    delete cleanedCustomer.auth0_id;
  }

  return cleanedCustomer;
};

// API only returns `secure_link` if it is active.
export const getIsSecureLinkActive = (
  secureLinkFlag: boolean,
  customer?: Maybe<Customer | GeneratedCustomer>,
) => !!(secureLinkFlag && customer && 'secure_link' in customer && customer.secure_link);
